/**
 * Jumps to a section instead of animating: the site sets `scroll-behavior:
 * smooth` globally, and that animation gets cancelled while the page is still
 * loading, leaving the guest stranded near the top. Fonts and images also keep
 * shifting the layout for a moment, so align again once the page has settled.
 */
const SETTLE_DELAY_MS = 500;

export const scrollToSection = (sectionId) => {
  const alignSection = () =>
    document
      .getElementById(sectionId)
      ?.scrollIntoView({ block: "start", behavior: "instant" });

  requestAnimationFrame(alignSection);
  setTimeout(alignSection, SETTLE_DELAY_MS);
};

/** Customer pages live under `/en/...` or `/jp/...`; default to Japanese. */
export const buildLocalizedPath = (language, path) => {
  const isEnglish = (language || "").toLowerCase() === "en";
  return `/${isEnglish ? "en" : "jp"}${path}`;
};
